import type { IconProps } from './IconProps';

export const ShrinkIcon = (props: IconProps) => (
  <svg
    viewBox="0 0 16 16"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    width={props.width ?? 16}
    height={props.height ?? 16}
    {...props}
  >
    <path
      d="M10.26 2.25C10.26 1.83579 9.92422 1.5 9.51001 1.5C9.0958 1.5 8.76001 1.83579 8.76001 2.25V6.49264C8.76001 6.90685 9.0958 7.24264 9.51001 7.24264H13.7527C14.1669 7.24264 14.5027 6.90685 14.5027 6.49264C14.5027 6.07843 14.1669 5.74264 13.7527 5.74264H10.26V2.25Z"
      fill="currentColor"
    />
    <path
      d="M5.74264 13.7524C5.74264 14.1666 6.07843 14.5024 6.49264 14.5024C6.90685 14.5024 7.24264 14.1666 7.24264 13.7524V9.50977C7.24264 9.09555 6.90685 8.75977 6.49264 8.75977H2.25C1.83579 8.75977 1.5 9.09555 1.5 9.50977C1.5 9.92398 1.83579 10.2598 2.25 10.2598H5.74264V13.7524Z"
      fill="currentColor"
    />
  </svg>
);
